import React from 'react';

const ZW = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_5"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_5)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#2B9300"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2H21V13H0V2Z"
        fill="#FFD300"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4H21V11H0V4Z"
        fill="#E11C00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6H21V9H0V6Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 0L12 7.5L1 15H0V0"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0L11 7.5L0 15V0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49999 8.75L3.02999 9.523L3.30999 7.886L2.12199 6.726L3.76499 6.489L4.49999 5L5.23499 6.49L6.87799 6.727L5.68799 7.887L5.96799 9.523"
        fill="#E11C00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 9H6V8L5 7C5 7 5 6 4 6H3L4 7L3 9Z"
        fill="#FFC700"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default ZW;
